module.exports = __webpack_public_path__ + "static/media/georgia bold italic.be45793e.ttf";